import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { heroSlides } from "@/mocks/home";

export default function HeroCarousel() {
  const [index, setIndex] = useState(0);
  const total = heroSlides.length;

  useEffect(() => {
    const timer = setInterval(() => setIndex((v) => (v + 1) % total), 5500);
    return () => clearInterval(timer);
  }, [total]);

  const go = (i: number) => setIndex((i + total) % total);

  return (
    <section className="relative w-full overflow-hidden bg-primary-950">
      <div className="relative h-[420px] w-full md:h-[600px]">
        {heroSlides.map((slide, i) => (
          <div
            key={slide.movieId}
            className={`absolute inset-0 transition-opacity duration-700 ${
              i === index ? "opacity-100" : "pointer-events-none opacity-0"
            }`}
          >
            <img
              src={slide.backdrop}
              alt={`${slide.title} 剧照`}
              title={`${slide.title} - 555电影`}
              className="h-full w-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/60 to-primary-950/20"></div>
          </div>
        ))}

        <div className="relative z-10 mx-auto flex h-full w-full items-center px-4 md:px-6">
          <div className="w-full max-w-2xl">
            <span className="mb-4 inline-flex items-center gap-2 rounded-full bg-accent-500 px-3 py-1 text-xs font-bold text-foreground-950">
              <span className="flex h-3 w-3 items-center justify-center">
                <i className="ri-fire-fill text-xs"></i>
              </span>
              {heroSlides[index].tag}
            </span>
            <h1 className="font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
              {heroSlides[index].title}
            </h1>
            <p className="mt-4 max-w-xl text-sm leading-relaxed text-background-200 md:text-base">
              {heroSlides[index].subtitle}
            </p>
            <div className="mt-7 flex flex-wrap items-center gap-3">
              <Link
                to={`/detail/${heroSlides[index].movieId}`}
                className="inline-flex items-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-400"
              >
                <span className="flex h-4 w-4 items-center justify-center">
                  <i className="ri-play-circle-line text-base"></i>
                </span>
                查看影片详情
              </Link>
              <Link
                to="/category"
                className="inline-flex items-center gap-2 rounded-md border border-background-50/40 px-5 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-background-50/10"
              >
                浏览全部分类
              </Link>
            </div>
          </div>
        </div>

        <button
          type="button"
          aria-label="上一张"
          onClick={() => go(index - 1)}
          className="absolute left-3 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur transition-colors hover:bg-background-50/30 md:left-6 md:h-11 md:w-11"
        >
          <i className="ri-arrow-left-s-line text-xl"></i>
        </button>
        <button
          type="button"
          aria-label="下一张"
          onClick={() => go(index + 1)}
          className="absolute right-3 top-1/2 z-10 flex h-9 w-9 -translate-y-1/2 items-center justify-center rounded-full bg-background-50/20 text-background-50 backdrop-blur transition-colors hover:bg-background-50/30 md:right-6 md:h-11 md:w-11"
        >
          <i className="ri-arrow-right-s-line text-xl"></i>
        </button>

        <div className="absolute bottom-6 left-1/2 z-10 flex -translate-x-1/2 items-center gap-2">
          {heroSlides.map((slide, i) => (
            <button
              key={slide.movieId}
              type="button"
              aria-label={`切换到第 ${i + 1} 张`}
              onClick={() => go(i)}
              className={`h-2 rounded-full transition-all ${
                i === index ? "w-8 bg-accent-500" : "w-2 bg-background-50/50 hover:bg-background-50/80"
              }`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}